import { createTheme } from "@material-ui/core/styles";
const theme = createTheme({
  palette: {
    primary: { main: "#FFFFFF" },
    secondary: { main: "#073762" },
  },
  text: {
    primary: "white",
    secondary: "#073762",
  },
});
export default theme;
